import script from "./AccessInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessInfo.vue?vue&type=script&setup=true&lang=js"

import "./AccessInfo.vue?vue&type=style&index=0&id=e3b84834&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3b84834"]])

export default __exports__